import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'mui-modal-body',
  template: '<ng-content></ng-content>',
  styles: [':host {display: block}']
})
export class MuiModalBody {
  @HostBinding('class.mui-modal__body') readonly _muiBaseClass = true;
}
